import React from 'react';
import PropTypes from 'prop-types';
import mapIcons from '../../../../assets/drawing.png';
import './terra-draw-controls.scss';

export const MODES = {
    SELECT: 'select',
    RECTANGLE: 'rectangle',
};

const ControlButton = ({ mode, currentMode, icon, onClick, disabled }) => (
    <button
        type="button"
        className={ `terra-btn ${ currentMode === mode ? 'active' : '' }` }
        disabled={ disabled }
        onClick={ onClick }
    >
        <span>
            <div className="img-wrapper">
                <img
                    alt=""
                    src={ mapIcons }
                    draggable="false"
                    className={ icon }
                />
            </div>
        </span>
    </button>
);

ControlButton.propTypes = {
    mode: PropTypes.string.isRequired,
    currentMode: PropTypes.string,
    icon: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};

ControlButton.defaultProps = {
    currentMode: MODES.SELECT,
    disabled: false,
};

export default function TerraDrawControls({ draw, currentMode, onModeChange }) {
    const handleModeChange = (mode) => {
        if (mode === MODES.SELECT && currentMode === MODES.RECTANGLE && draw?.__finalizeRectangle) {
            draw.__finalizeRectangle();
            return;
        }
        draw?.setMode?.(mode);
        onModeChange?.(mode);
    };

    return (
        <div className="terra-draw-controls">
            <ControlButton
                mode={ MODES.SELECT }
                currentMode={ currentMode }
                icon="img-pan"
                onClick={ () => handleModeChange(MODES.SELECT) }
                disabled={ !draw }
            />
            <ControlButton
                mode={ MODES.RECTANGLE }
                currentMode={ currentMode }
                icon="img-select"
                onClick={ () => handleModeChange(MODES.RECTANGLE) }
                disabled={ !draw }
            />
        </div>
    );
}

TerraDrawControls.propTypes = {
    draw: PropTypes.shape({
        setMode: PropTypes.func,
        __finalizeRectangle: PropTypes.func,
    }),
    currentMode: PropTypes.string,
    onModeChange: PropTypes.func,
};

TerraDrawControls.defaultProps = {
    draw: {
        setMode: () => {},
    },
    currentMode: MODES.SELECT,
    onModeChange: () => {},
};
